import * as enums from "@/app/enums/common";
import { types } from "@/app/types/types";

const state = {
	[types.STATE_LAST_ERROR]: {},
	[types.STATE_ERROR_LOG]: [],
	[types.STATE_DEBUG_LOG]: [],
	[types.STATE_APP_BUSY_STATE]: enums.appBusyStateEnum.IDLE,
	[types.STATE_APP_FEEDBACK_STATE]: enums.appFeedbackStateEnum.NONE,
	[types.STATE_COMPONENT_BUSY_STATE]: enums.componentBusyStateEnum.IDLE,
	[types.STATE_MODAL_IS_VISIBLE]: false,
	[types.STATE_MODAL_PROFILEEDIT_IS_VISIBLE]: false
};

const getters = {
	[types.GET_LAST_ERROR]: (state) =>
	{
		return state[types.STATE_LAST_ERROR]
	},

	[types.GET_ERROR_LOG]: (state) =>
	{
		return state[types.STATE_ERROR_LOG]
	},

	[types.GET_DEBUG_LOG]: (state) =>
	{
		return state[types.STATE_DEBUG_LOG]
	},

	[types.GET_APP_BUSY_STATE]: (state) =>
	{
		return state[types.STATE_APP_BUSY_STATE]
	},

	[types.GET_COMPONENT_BUSY_STATE]: (state) =>
	{
		return state[types.STATE_COMPONENT_BUSY_STATE]
	},

	[types.GET_APP_FEEDBACK_STATE]: (state) =>
	{
		return state[types.STATE_APP_FEEDBACK_STATE]
	},

	[types.GET_MODAL_IS_VISIBLE]: (state) =>
	{
		return state[types.STATE_MODAL_IS_VISIBLE]
	},

	[types.GET_MODAL_PROFILEEDIT_IS_VISIBLE]: (state) =>
	{
		return state[types.STATE_MODAL_PROFILEEDIT_IS_VISIBLE]
	}
};

const mutations = {
	[types.MUTATE_ADD_ERRORLOG_ENTRY]: (state, payload) =>
	{
		state[types.STATE_LAST_ERROR] = payload;
		state[types.STATE_ERROR_LOG].push(payload);
		logError(payload.reference, payload.message, payload.payload)
	},

	[types.MUTATE_ADD_DEBUGLOG_ENTRY]: (state, payload) =>
	{
		state[types.STATE_DEBUG_LOG].push(payload);
		logDebug(payload.reference, payload.message, payload.payload)
	},

	[types.MUTATE_SET_APP_BUSY_STATE]: (state, payload) =>
	{
		state[types.STATE_APP_BUSY_STATE] = payload
	},

	[types.MUTATE_SET_COMPONENT_BUSY_STATE]: (state, payload) =>
	{
		state[types.STATE_COMPONENT_BUSY_STATE] = payload
	},

	[types.MUTATE_SET_APP_FEEDBACK_STATE]: (state, payload) =>
	{
		state[types.STATE_APP_FEEDBACK_STATE] = payload
	},

	[types.MUTATE_SET_MODAL_VISIBILITY]: (state, payload) =>
	{
		state[types.STATE_MODAL_IS_VISIBLE] = payload
	},

	[types.MUTATE_SET_MODAL_PROFILEEDIT_VISIBILITY]: (state, payload) =>
	{
		state[types.STATE_MODAL_PROFILEEDIT_IS_VISIBLE] = payload
	}
};

const actions = {
	[types.ACTION_ADD_ERRORLOG_ENTRY]: ({ commit }, reference, message, payload) =>
	{
		commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: reference, message: message, payload: payload });
	},

	[types.ACTION_ADD_DEBUGLOG_ENTRY]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, payload);
	},

	[types.ACTION_SET_APP_BUSY_STATE]: ({ commit, dispatch }, payload) =>
	{
		commit(types.MUTATE_SET_APP_BUSY_STATE, payload );
		dispatch(types.ACTION_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SET_APP_BUSY_STATE, payload: payload })
	},

	[types.ACTION_SET_COMPONENT_BUSY_STATE]: ({ commit, dispatch }, payload) =>
	{
		commit(types.MUTATE_SET_COMPONENT_BUSY_STATE, payload);
		dispatch(types.ACTION_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SET_COMPONENT_BUSY_STATE, payload: payload })
	},

	[types.ACTION_SET_APP_AS_IDLE]: ({ commit, dispatch }) =>
	{
		commit(types.MUTATE_SET_APP_BUSY_STATE, enums.appBusyStateEnum.IDLE);
		dispatch(types.ACTION_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SET_APP_AS_IDLE, payload: enums.appBusyStateEnum.IDLE })
	},

	[types.ACTION_SET_APP_AS_BUSY]: ({ commit, dispatch }) =>
	{
		commit(types.MUTATE_SET_APP_BUSY_STATE, enums.appBusyStateEnum.BUSY);
		dispatch(types.ACTION_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SET_APP_AS_BUSY, payload: enums.appBusyStateEnum.BUSY })
	},

	[types.ACTION_SET_APP_AS_BUSYMODAL]: ({ commit, dispatch }) =>
	{
		commit(types.MUTATE_SET_APP_BUSY_STATE, enums.appBusyStateEnum.BUSYMODAL);
		dispatch(types.ACTION_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SET_APP_AS_BUSYMODAL, payload: enums.appBusyStateEnum.BUSYMODAL })
	},

	[types.ACTION_SET_APP_FEEDBACK_STATE]: ({ commit, dispatch }, payload) =>
	{
		commit(types.MUTATE_SET_APP_FEEDBACK_STATE, payload);
		dispatch(types.ACTION_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SET_APP_FEEDBACK_STATE, payload: payload })
	},

	[types.ACTION_SET_MODAL_VISIBILITY]: ({ commit, dispatch }, payload) =>
	{
		commit(types.MUTATE_SET_MODAL_VISIBILITY, payload);
		dispatch(types.ACTION_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SET_MODAL_VISIBILITY, payload: payload })
	},

	[types.ACTION_SET_MODAL_PROFILEEDIT_VISIBILITY]: ({ commit, dispatch }, payload) =>
	{
		commit(types.MUTATE_SET_MODAL_PROFILEEDIT_VISIBILITY, payload);
		dispatch(types.ACTION_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_SET_MODAL_PROFILEEDIT_VISIBILITY, payload: payload })
	}
}

export default
	{
		state,
		mutations,
		actions,
		getters
	}
